import script from "./ChHair.vue?vue&type=script&setup=true&lang=js"
export * from "./ChHair.vue?vue&type=script&setup=true&lang=js"

import "./ChHair.vue?vue&type=style&index=0&id=036d9fb9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-036d9fb9"]])

export default __exports__